import { orderProcessorContract } from "@/contexts/SmartWallet";
import { readContract } from "thirdweb";

const getAssingedOrders = async (account: { address: string }) => {
  const assingedOrders = await readContract({
    contract: orderProcessorContract,
    method: "fetchMerchantAssignedOrders",
    params: [account.address],
  });
  return assingedOrders;
};

const getAcceptedOrders = async (account: { address: string }) => {
  const acceptedOrders = await readContract({
    contract: orderProcessorContract,
    method: "fetchMerchantAcceptedOrders",
    params: [account.address],
  });
  return acceptedOrders;
};

const getOrders = async (orderId: string) => {
  const acceptedOrders = await readContract({
    contract: orderProcessorContract,
    method: "orders",
    params: [orderId],
  });
  return acceptedOrders;
};

export { getAssingedOrders, getAcceptedOrders, getOrders };
